<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div class="main-content-wrap" style="padding-top: 15px">
          <a-row>
            <a-col :span="24">
              <a-table :loading="table.loading"
                       :data-source="table.data"
                       :default-sort="table.sort"
                       :pagination="table.pagination"
                       @change="handleTableChange"
                       ref="table.dataRef">
                <a-table-column align="center" data-index="user.userName" title="用户名" width="">
                </a-table-column>
                <a-table-column align="center" data-index="active" title="操作描述" width="">
                </a-table-column>
                <a-table-column align="center" data-index="url" title="url" width="">
                </a-table-column>
                <a-table-column align="center" data-index="createAt" title="操作时间" width="">
                </a-table-column>
              </a-table>
<!--              <div style="margin-top: 20px;text-align: center;">-->
<!--                <a-pagination @size-change="handleSizeChange"-->
<!--                               @current-change="handleCurrentChange"-->
<!--                               :current-page="listQuery.page"-->
<!--                               :page-sizes="[10, 50,100]"-->
<!--                               :page-size="listQuery.size"-->
<!--                               layout="total, sizes, prev, pager, next, jumper"-->
<!--                               :total="listQuery.totalAmount">-->
<!--                </a-pagination>-->
<!--              </div>-->
            </a-col>
          </a-row>
      </div>
    </div>

  </a-card>
</template>

<script>
import { getLogsList } from '../../../api/log';

/**
   * 初始化用户列表数据
   */
async function getList() {
  const currentPage = this.table.pagination.current - 1;
  const result = await getLogsList(currentPage, this.table.pagination.pageSize);
  if (result.code === 1200) {
    this.table.data = result.data.logs;
    this.table.pagination.total = result.data.totalCount;
  }
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

export default {
  components: {
  },
  methods: {
    getList,
    handleTableChange
  },
  created() {
    this.getList();
  },
  data() {
    return {
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
      },
      form: {
        data: {
        },
      },
    };
  },
};
</script>
